import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../../../../environments/environment';
import { Observable } from 'rxjs';
import { MessageNotificationProgress } from '@app/pages/constructor/constructor-components/communication-chart/enum/message-notification-progress.enum';
import { MessageNotificationRes } from '@app/pages/constructor/constructor-components/communication-chart/models/message-notification-view.model';
import { CommunicationChartUnreadCountModel } from '@app/pages/constructor/constructor-components/communication-chart/models/communication-chart-unread-count.model';

@Injectable({
  providedIn: 'root'
})
export class CommunicationChartPanelService {
  private readonly baseApi = environment.communicationApi;

  constructor(private http: HttpClient) {}

  public getCommunicationChartPanel(
    currentPage: number,
    pageSize: number,
    progress: MessageNotificationProgress | null,
    isGetAll: boolean
  ): Observable<MessageNotificationRes> {
    let params = new HttpParams()
      .set('CurrentPage', currentPage.toString())
      .set('PageSize', pageSize.toString())
      .set('IsGetAll', isGetAll);

    if (progress !== null) {
      params = params.set('MessageNotificationProgress', progress.toString());
    }

    return this.http.get<MessageNotificationRes>(
      `${this.baseApi}/Notifications/search`,
      {
        params
      }
    );
  }

  public deleteCommunicationChartNotification(id: string): Observable<string> {
    return this.http.delete<string>(`${this.baseApi}/Notifications/${id}`);
  }

  public viewCommunicationNotifyById(id: string): Observable<string> {
    return this.http.post<string>(
      `${this.baseApi}/Notifications/${id}/read`,
      {}
    );
  }

  public viewAllCommunicationChartNotify(): Observable<string> {
    return this.http.post<string>(`${this.baseApi}/Notifications/read`, {});
  }

  public getCountUnreadNotificationChart(): Observable<CommunicationChartUnreadCountModel> {
    return this.http.get<CommunicationChartUnreadCountModel>(
      `${this.baseApi}/Notifications/count`
    );
  }
}
